export default __webpack_public_path__ + "static/media/img_22.6c654d5e.jpg";